import { Component, HostListener, Input } from '@angular/core';
import { KmShellI, KmType } from '../file-import/models/km-shell.interface';
import { months } from 'src/app/interfaces/month.array';
import * as echarts from 'echarts';

@Component({
  selector: 'app-stats-km-shell-graph',
  templateUrl: './stats-km-shell-graph.component.html',
  styleUrls: ['./stats-km-shell-graph.component.css'],
})
export class StatsKmShellGraphComponent {
  @Input() kmShell!: KmShellI[];

  kmType = KmType;
  meses = months;

  data: { tipo: string; values: { mes: string; value: number }[] }[] = [];

  ngOnInit() {
    this.kmShell.sort(
      (a, b) => new Date(a.period).getTime() - new Date(b.period).getTime()
    );
    this.kmShell.forEach((km) => {
      let a = this.data.find((d) => d.tipo == km.type);
      if (!a) {
        this.data.push({ tipo: km.type, values: [] });
        a = this.data[this.data.length - 1];
      }
      let b = a.values.find(
        (v) => v.mes == this.meses[new Date(km.period).getMonth()].nameShort
      );
      if (!b) {
        a.values.push({
          mes: this.meses[new Date(km.period).getMonth()].nameShort,
          value: 0,
        });
        b = a.values[a.values.length - 1];
      }
      b.value += +km.value[0];
    });
    this.setChart();
  }

  myChart!: echarts.ECharts;
  setChart() {
    this.myChart = echarts.init(document.getElementById('main-shell'));
    const option = {
      xAxis: {
        type: 'category',
        data: this.meses.map((i) => i.nameShort),
      },
      yAxis: [
        {
          type: 'value',
          name: 'Kilómetros',
        },
        {
          type: 'value',
          name: 'Frenadas bruscas',
        },
      ],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
        },
      },
      legend: {
        data: ['Kilómetros', 'Frenadas bruscas'],
        bottom: 0,
      },
      series: [
        {
          name: 'Kilómetros',
          data: this.data
            .find((d) => d.tipo == this.kmType.km)
            ?.values.map((v) => v.value),
          type: 'bar',
        },
        {
          name: 'Frenadas bruscas',
          data: this.data
            .find((d) => d.tipo == this.kmType.frenadas)
            ?.values.map((v) => v.value),
          type: 'line',
          yAxisIndex: 1,
        },
      ],
      textStyle: {
        fontFamily: 'ShellLight',
      },
    };
    this.myChart.setOption(option);
  }

  getValue(month: number, tipo: KmType) {
    const value = this.kmShell
      .filter(
        (km) => new Date(km.period).getMonth() + 1 == month && km.type == tipo
      )
      .map((km) => +km.value[0])
      .reduce((count, value) => count + value, 0);

    if (value > 0)
      return Number.isInteger(+value) ? value : (+value).toFixed(2);
    else return value;
  }

  show = true;
  rotate = false;

  hide() {
    this.rotate = !this.rotate;
    this.show = !this.show;
  }

  @HostListener('window.resize', ['$event'])
  onResize() {
    this.myChart.resize();
  }
}
